import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { LetsikringAfIndtaegt } from '@features/letregister/letsikring-af-indtaegt.model';
import { LetsikringRevision } from '@features/letregister/letsikring-revision.model';
import { LetsikringRisiko } from '@features/letregister/letsikring-risiko.model';
import { Letsikring } from '@features/letregister/letsikring.model';
import { DetailRowComponent } from '@shared/detail-row/detail-row.component';
import { LetDatePickerComponent } from '@shared/let-datepicker/let-date-picker.component';
import { Checkbox } from 'primeng/checkbox';
import { InputNumber } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-letsikring-stamoplysninger',
  imports: [
    DatePipe,
    BooleanPipe,
    ReactiveFormsModule,
    InputTextModule,
    TextareaModule,
    Checkbox,
    Select,
    InputNumber,
    LetDatePickerComponent,
    DetailRowComponent,
  ],
  templateUrl: './letsikring-stamoplysninger.component.html',
  styleUrl: './letsikring-stamoplysninger.component.css',
})
export default class LetsikringStamoplysningerComponent {
  form = input.required<FormGroup>();
  editMode = input.required<boolean>();
  letsikring = input.required<Letsikring>();
  revision = input.required<LetsikringRevision>();
  livrente = input.required<LetsikringAfIndtaegt | undefined>();
  risiko = input.required<LetsikringRisiko | undefined>();

  pensionsreformOptions = [
    { text: 'Oprettet før 1. maj 2007', value: 'GamleRegler' },
    { text: 'Oprettet 1. maj 2007 - 31. december 2017', value: 'Reform2007' },
    { text: 'Oprettet 1. januar 2018 eller senere', value: 'Reform2018' },
  ];

  tegningsmaadeOptions = [{ value: 'Privat' }, { value: 'Arbejdsgiver' }];

  getPensionsreformText(value: string) {
    const found = this.pensionsreformOptions.filter(x => x.value === value);
    if (found.length > 0) {
      return found[0].text;
    }
    return '';
  }
}
